import React from "react";
import { Cell } from "react-mdl/lib/Grid";

export default class CustomCell extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            hideDesktop = false,
            hidePhone = false,
            hideTablet = false,
            style = {}
        } = this.props;
        return (
            <Cell
                {...this.props}
                hideDesktop={hideDesktop}
                hidePhone={hidePhone}
                hideTablet={hideTablet}
                style={Object.assign({}, style)}
            />
        );
    }
}
